// extracted by mini-css-extract-plugin
export var active = "_3x-7";
export var container = "_3x-0";
export var evenWidth = "_3x-4";
export var large = "_3x-5";
export var outlet = "_3x-8";
export var slide = "_3x-2";
export var small = "_3x-6";
export var tab = "_3x-3";
export var tabs = "_3x-1";